// Map option from select dropdown to display in table
export const mapFromSelectToTable = (value) => {
  return { id: value.id, name: value.text, features: value.features };
};

// Function to transform the data to display in the table
export const transformOfficerData = (data) => {
  // Extract the id and name
  const { id, name } = data;

  // Return the transformed object
  return {
    id,
    name,
    features: `Badge Number: ${data.badgeNumber ?? "N/A"} - Phone: ${
      data.phoneNumber ?? "N/A"
    } - Address: ${data.address1}, ${data.address2}, ${data.town}, ${data.postcode}`,
  };
};
